export default "__VITE_ASSET__cdf506ac__"